import { queryOptions } from '@tanstack/react-query';
import type {
  DuoChatResponse,
  GetOrCreateDuoChatData,
} from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';
import type { ReplacePathParams } from '@/shared/utils/pathParams';

export interface DuoChatKeyParams {
  duoId: string;
}

export const getDuoChatKey = ({ duoId }: DuoChatKeyParams) =>
  ['duos', duoId, 'chat'] as const;

const getDuoChatUrl = (
  userId: string | number,
): ReplacePathParams<GetOrCreateDuoChatData['url']> =>
  `duos/${userId.toString()}/chat`;

export const getDuoChatOptions = <T = DuoChatResponse>(
  params: DuoChatKeyParams,
) =>
  queryOptions<DuoChatResponse, unknown, T>({
    queryKey: getDuoChatKey(params),
    queryFn: () =>
      // POST creates the chat if it doesn't exist, otherwise returns the existing chat
      PrivateApi.post(getDuoChatUrl(params.duoId)).json<DuoChatResponse>(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
